import { render, staticRenderFns } from "./PIIRiskEventsBoard.vue?vue&type=template&id=3e90a039&"
import script from "./PIIRiskEventsBoard.vue?vue&type=script&lang=ts&"
export * from "./PIIRiskEventsBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports